import React from 'react';

const EuroFormatter = ({ amount }) => {
    const formatEuro = (value) => {
        return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    };

    return formatEuro(amount)
};

export default EuroFormatter;

